import Dispatchers from '@/mixins/dispatchers';

export default {
    name: 'RelatedIssues',
    mixins: [Dispatchers],
    /**
     * @override
     */
    data() {
        return {
            relatedIssues: {
                fields: [
                    {
                        key: 'blocking',
                        label: '',
                        class: 'blocking'
                    },
                    {
                        key: 'subject',
                        label: 'Título',
                        class: 'subject'
                    },
                    {
                        key: 'key_issue_category',
                        label: 'Categoría'
                    },
                    // {
                    //     key: 'uuid',
                    //     label: 'Código',
                    //     class: 'uuid'
                    // },
                    {
                        key: 'description',
                        label: 'Descripción',
                        class: 'description'
                    },
                    {
                        key: 'status',
                        label: 'Estado',
                        class: 'issue-status'
                    },
                    {
                        key: 'created_on',
                        label: 'Fecha apertura'
                    },
                    {
                        key: 'expires_on',
                        label: 'Fecha caducidad'
                    }
                ]
            }
        };
    },
    props: {
        issuesResolved: {
            type: Array,
            required: true
        },
        issuesNotResolved: {
            type: Array,
            required: true
        },
        object: {
            type: Object,
            required: false
        },
        type: {
            type: String,
            required: true
        }
    },
    methods: {
        /**
         * Load tab to create new issue
         */
        createIssue() {
            let type;
            let subject;
            let alias;
            switch (this.type) {
                case 'account':
                    type = 'ACCOUNT';
                    subject = `Incidencia de cuenta ${this.object.id_object}`;
                    alias = this.object.id_object;
                    break;
                case 'intervener':
                    type = 'INTERVENER';
                    subject = `Incidencia ${this.object.personal_data.name} ${this.object.personal_data.lastname_1}`;
                    alias = `${this.object.personal_data.name} ${this.object.personal_data.lastname_1}`;
                    break;
                case 'operation':
                    type = 'OPERATION';
                    subject = `Incidencia ${this.object.id_object}`;
                    alias = `Incidencia ${this.object.id_object}`;
                    break;
                default:
                    return;
            }
            const _route = {
                name: 'issues_add_view',
                params: [],
                query: {
                    type,
                    alias,
                    subject,
                    name: subject,
                    view: 'issue-details',
                    id: this.object.uuid || this.$route.params.uuid
                }
            };
            const item = {
                route: _route,
                name: subject,
                active: true
            };
            this.$router.push(item.route);
        }
    }
};
